// extracted by mini-css-extract-plugin
module.exports = {"Items":"AboutHero_Items__iN8J8","Item":"AboutHero_Item__UeKEz","LearnMore":"AboutHero_LearnMore__6MtCW"};